export default "__VITE_ASSET__96380d86__"